import { jsx as _jsx } from "react/jsx-runtime";
export function MessageTimestamp({ timestamp }) {
    if (!timestamp)
        return null;
    const date = new Date(timestamp);
    if (!Number.isFinite(date.getTime()))
        return null;
    const full = date.toLocaleString();
    return _jsx("time", { className: "agent-message-time", dateTime: timestamp, title: full, "aria-label": full, children: date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }) });
}
//# sourceMappingURL=MessageTimestamp.js.map